<template>
  <div class="card">
    <div
      class="card-header"
      :class="{ warning: isCoverFrame && hasCoverFrameWarning }"
    >
      <img class="icon" :src="category.img" />

      <h1 class="heading">{{ category.name }}</h1>

      <span class="amount">
        <template v-if="isCoverFrame">
          <TweenPrice
            class="big"
            :price="currentCoverFrameAmount"
            :with-format="false"
          />
          <span>/</span>
          <TweenPrice :price="requiredCoverFrameAmount" :with-format="false" />
        </template>
        <template v-else>
          <TweenPrice
            :price="categoryAmount"
            :with-format="false"
            class="amount"
          />
          <span class="each">{{ $t('global.word.pieces') }}</span>
        </template>
      </span>
    </div>
    <div class="card-content">
      <ProductRow
        v-for="product in products"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import coverFrameMixin from '../../mixins/cover-frame-mixin';
import ProductRow from './ProductRow';
import TweenPrice from '../utilities/TweenPrice';

export default {
  name: 'CategoryCard',
  mixins: [coverFrameMixin],
  components: {
    TweenPrice,
    ProductRow,
  },
  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      buildProducts: 'build/getProducts',
      getProductsByCategory: 'category-products/getProductsByCategory',
    }),
    products() {
      return this.getProductsByCategory(this.category.id);
    },
  },
};
</script>
